// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#overview-patent-tab .v-toolbar{background:#fafafa!important;border-bottom:2px solid #f4f2f9!important}#overview-patent-tab .custom-app-bar{background-color:transparent!important;border-bottom:none!important}", ""]);
// Exports
module.exports = exports;
